import App from "./app";


document.addEventListener('DOMContentLoaded', ()=>{
  const app = new App();
  app.init();
})